const loggedInButtons = document.querySelectorAll(".logged-in-button");

if (loggedInButtons.length) {
  [].forEach.call(loggedInButtons, (loggedInButton) => {
    loggedInButton.addEventListener("click", () => {
      loggedInButton.classList.toggle("active");
    });
  });
}
